








































































import Vue from 'vue';
import { CustomerRemarkRule, CustomerRemarkRuleType } from '../../models/CustomerRemarkRule';
import commonVuex from '../../../common/vuex/common';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import customerClient from '../../apis';
import moment from 'moment';

enum RuleMode {
  Valid = 0,
  Expired = -1,
  Disabled = -100,
}

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    RiskBox,
  },
  props: {
    rule: {
      type: Object,
      default: RuleMode.Valid,
    },
    mode: {
      type: Number,
      default: 0,
    },
    slinks: {
      type: Array as () => object[],
      default: [],
    },
  },
  data() {
    return {
      showDelete: false,
      CustomerRemarkRuleType,
      RuleMode,
    };
  },
  computed: {
    itemLink(): string {
      return [
        'https://',
        this.account.domain,
        '.weixin.drip.im/wx-wap/crm?special=',
        this.account.domain,
        '&vuePath=slink&code=',
        this.getCode(),
      ].join('');
    },
    classes(): string[] {
      const clas = [];
      if (this.rule.type === CustomerRemarkRuleType.Link) {
        clas.push('icon-ball');
      }
      if (this.rule.type === CustomerRemarkRuleType.Keyword) {
        clas.push('icon-say');
      }
      return clas;
    },
    notValid(): boolean {
      return this.rule.period.startAt >  moment().format('YYYY-MM-DD hh:mm:ss');
    },
  },
  methods: {
    doDelete() {
      customerClient.deleteRemarkRule({
        id: this.rule.id,
        type: this.rule.type,
      }).success((r: any) => {
        this.$Message.success('删除成功');
        this.showDelete = false;
        this.$emit('refresh');
      });
    },
    onCopy() {
      this.$Message.success('复制成功');
    },
    getCode(): string {
      const slink = this.slinks.find((slink: any) => {
        return parseInt(slink.sid) === this.rule.id;
      });
      return slink ? (slink as any).code : '';
    },
  },
});
